import { useState } from 'react';
import styles from './FailureModalNoAuth.module.scss';
import { Text } from '../../../components/typography';
import { useTranslation } from 'react-i18next';
import { keys } from '../../../utilities/translator/translation_keys';
import Icon from '../../../components/Icon';
import { Form } from 'react-bootstrap';
import { Button } from '../../../components';

export default function FailureModalNoAuth({
  onSubmit,
  setModalState,
  modalState,
}) {
  const { title = '', description = '' } = modalState ?? {};
  const { t } = useTranslation();
  const [notes, setNotes] = useState('');

  const onHide = () => {
    setModalState((prev) => ({ ...prev, show: false }));
    setNotes('');
  };

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <div className={styles.header}>
          <Text weight="bold" size="lg" noMargin>
            {t(keys.assessments.WHAT_WENT_WRONG)}
          </Text>
          <Icon className={styles.closeIcon} onClick={() => onHide()}>
            close
          </Icon>
        </div>
        <br />
        <div>
          <div className={styles.title}>
            <Text noMargin weight="bold" color="red" size="lg">
              {title}
            </Text>
            <Icon
              sx={{ fontSize: '2rem' }}
              className={styles.icon}
              fontSize="inherit"
              baseClassName="material-icons-outlined"
            >
              cancel
            </Icon>
          </div>
          <Text size="md">{description}</Text>
        </div>
        <Text className={styles.formLabel} weight="bold" noMargin>
          {`${t(keys.common.NOTES)}*`}
        </Text>
        <Form onSubmit={(e) => e.stopPropagation()}>
          <Form.Group>
            <Form.Control
              type="text"
              as="textarea"
              required
              placeholder={t(keys.assessments.FAILURE_NOTES)}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
            <Form.Control.Feedback type="invalid">
              {t(keys.assessments.NOTES_VALIDATION)}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
        <div className={styles.buttons}>
          <Button
            size="md"
            variant="secondary"
            value={t(keys.action.CANCEL)}
            onClick={() => onHide()}
          />
          <Button
            size="md"
            variant="danger"
            disabled={!notes?.length}
            value={t(keys.action.SUBMIT)}
            onClick={() => {
              onSubmit(notes);
              onHide();
            }}
          />
        </div>
      </div>
    </div>
  );
}
